// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect } from "react";
// import { useTranslation } from "react-i18next";
// import { Link, useLocation } from "react-router-dom";
// import { Badges, LI, SVG, UL } from "../../AbstractElements";
// import SvgIcon from "../../CommonElements/SVG/SvgIcon";
// import { useAppDispatch, useAppSelector } from "../../ReduxToolkit/Hooks";
// import { handlePined } from "../../ReduxToolkit/Reducers/LayoutSlice";
// import { MenuListType, SidebarItemTypes } from "../../Type/Layout/Sidebar";
// import { Href } from "../../utils/Constant";

// const MenuLists: React.FC<MenuListType> = ({
//   menu,
//   setActiveMenu,
//   activeMenu,
//   level,
//   className,
// }) => {
//   const { pinedMenu } = useAppSelector((state) => state.layout);
//   const location = useLocation();
//   const dispatch = useAppDispatch();
//   const { t } = useTranslation();

//   const ActiveNavLinkUrl = (path?: string) => {
//     return location.pathname === path ? true : "";
//   };

//   const shouldSetActive = ({ item }: SidebarItemTypes) => {
//     var returnValue = false;
//     if (item?.path === location.pathname) returnValue = true;
//     if (!returnValue && item?.children) {
//       item?.children.every((subItem) => {
//         returnValue = shouldSetActive({ item: subItem });
//         return !returnValue;
//       });
//     }
//     return returnValue;
//   };

//   const handleClick = (item: string) => {
//     const temp = activeMenu;
//     temp[level] = item !== temp[level] ? item : "";
//     setActiveMenu([...temp]);
//   };

//   // useEffect(() => {
//   //   menu?.forEach((item: any) => {
//   //     let gotValue = shouldSetActive({ item });
//   //     if (gotValue) {
//   //       let temp = [...activeMenu];
//   //       temp[level] = item.title;
//   //       setActiveMenu(temp);
//   //     }
//   //   });
//   // }, []);

//   return (
//     <>
//       {menu?.map((item, index) => (
//         <LI
//           key={index}
//           className={`${level === 0 ? "sidebar-list" : ""} ${
//             pinedMenu.includes(item.title || "") ? "pined" : ""
//           }
//           ${
//             (item.children
//               ? item.children
//                   .map((innerItem) => ActiveNavLinkUrl(innerItem.path))
//                   .includes(true)
//               : ActiveNavLinkUrl(item.path)) || activeMenu[level] === item.title
//               ? "active"
//               : ""
//           } `}
//         >
//           {level === 0 && (
//             <SVG
//               className="pinned-icon"
//               iconId="Pin"
//               onClick={() => dispatch(handlePined(item.title))}
//             />
//           )}
//           <Link
//             className={`${
//               !className
//                 ? "sidebar-link sidebar-title"
//                 : item.type === "sub"
//                 ? "submenu-title"
//                 : ""
//             }
//             ${
//               (item.children
//                 ? item.children
//                     .map((innerItem) => ActiveNavLinkUrl(innerItem.path))
//                     .includes(true)
//                 : ActiveNavLinkUrl(item.path)) ||
//               activeMenu[level] === item.title
//                 ? "active"
//                 : ""
//             }`}
//             to={item.path ? item.path : Href}
//             onClick={() => handleClick(item.title)}
//           >
//             {level === 0 ? (
//               <SVG className={`stroke-icon`} iconId={item.icon} />
//             ) : (
//               level === 1 && <SVG className={`svg-menu`} iconId={"right-3"} />
//             )}
//             <span
//               style={{
//                 whiteSpace: "normal",
//                 overflowWrap: "break-word",
//                 wordBreak: "break-word",
//                 lineHeight: "1.2",
//                 display: "block",
//               }}
//             >
//               {t(item.title)}
//             </span>
//             {item.badge && (
//               <Badges pill color="primary">
//                 {item.badge}
//               </Badges>
//             )}
//             {item.children &&
//               (activeMenu[level] === item.title ? (
//                 <SvgIcon iconId="chevron-right" className="feather" />
//               ) : (
//                 <SvgIcon iconId="chevron-right" className="feather" />
//               ))}
//           </Link>
//           {item.children && (
//             <UL
//               className={`simple-list ${
//                 level !== 0
//                   ? "nav-sub-childmenu submenu-content"
//                   : "sidebar-submenu "
//               }`}
//               style={{
//                 display: `${
//                   (item.children
//                     ? item.children
//                         .map((innerItem) => ActiveNavLinkUrl(innerItem.path))
//                         .includes(true)
//                     : ActiveNavLinkUrl(item.path)) ||
//                   activeMenu[level] === item.title
//                     ? "block"
//                     : "none"
//                 }`,
//               }}
//             >
//               <MenuLists
//                 menu={item.children}
//                 activeMenu={activeMenu}
//                 setActiveMenu={setActiveMenu}
//                 level={level + 1}
//                 className="sidebar-submenu"
//               />
//             </UL>
//           )}
//         </LI>
//       ))}
//     </>
//   );
// };

// export default MenuLists;

/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Badges, LI, SVG, UL } from "../../AbstractElements";
import SvgIcon from "../../CommonElements/SVG/SvgIcon";
import { useAppDispatch, useAppSelector } from "../../ReduxToolkit/Hooks";
import { handlePined } from "../../ReduxToolkit/Reducers/LayoutSlice";
import { MenuListType } from "../../Type/Layout/Sidebar";
import { Href } from "../../utils/Constant";
import { resetAllFilter } from "../../ReduxToolkit/Reducers/Expense/ResetAllFilters"; 

const MenuLists: React.FC<MenuListType> = ({
  menu,
  setActiveMenu,
  activeMenu,
  level,
  className,
}) => {
  const { pinedMenu } = useAppSelector((state) => state.layout);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // ✅ Only update activeMenu on click
  const handleClick = (item: any) => {
    dispatch(resetAllFilter());
    const temp = [...activeMenu];
    // toggle parent
    temp[level] = item.title !== temp[level] ? item.title : "";

    // ✅ If parent has children, auto-select first child
    if (item.children && item.children.length > 0) {
      temp[level + 1] = item.children[0].title;
    }

    setActiveMenu(temp);
  };

  return (
    <>
      {menu?.map((item, index) => (
        <LI
          key={index}
          className={`${level === 0 ? "sidebar-list" : ""} 
            ${pinedMenu.includes(item.title || "") ? "pined" : ""}  
            ${activeMenu[level] === item.title ? "active" : ""}`}
        >
          {level === 0 && (
            <SVG
              className="pinned-icon"
              iconId="Pin"
              onClick={() => dispatch(handlePined(item.title))}
            />
          )}

          <Link
            className={`${
              !className
                ? "sidebar-link sidebar-title"
                : item.type === "sub"
                ? "submenu-title"
                : ""
            } ${activeMenu[level] === item.title ? "active" : ""}`}
            to={item.path ? item.path : Href}
            onClick={() => handleClick(item)}
          >
            {level === 0 ? (
              <SVG className={`stroke-icon`} iconId={item.icon} />
            ) : (
              level === 1 && <SVG className={`svg-menu`} iconId={"right-3"} />
            )}

            <span
              style={{
                whiteSpace: "normal",
                overflowWrap: "break-word",
                wordBreak: "break-word",
                lineHeight: "1.2",
                display: "block",
              }}
            >
              {t(item.title)}
            </span>

            {item.badge && (
              <Badges pill color="primary">
                {item.badge}
              </Badges>
            )}

            {item.children && (
              <SvgIcon iconId="chevron-right" className="feather" />
            )}
          </Link>

          {item.children && (
            <UL
              className={`simple-list ${
                level !== 0
                  ? "nav-sub-childmenu submenu-content"
                  : "sidebar-submenu"
              }`}
              style={{
                display: activeMenu[level] === item.title ? "block" : "none",
              }}
            >
              <MenuLists
                menu={item.children}
                activeMenu={activeMenu}
                setActiveMenu={setActiveMenu}
                level={level + 1}
                className="sidebar-submenu"
              />
            </UL>
          )}
        </LI>
      ))}
    </>
  );
};

export default MenuLists;
